"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserGroupAccessGrantee = exports.isUserAccessGrantee = exports.isUserGroupAccess = exports.isUserAccess = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Tests whether the provided object is an instance of {@link IUserAccess}.
 *
 * @param obj - object to test
 * @alpha
 */
exports.isUserAccess = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "user";
};
/**
 * Tests whether the provided object is an instance of {@link IUserGroupAccess}.
 *
 * @param obj - object to test
 * @alpha
 */
exports.isUserGroupAccess = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "group";
};
/**
 * Tests whether the provided object is an instance of {@link IUserAccessGrantee}.
 *
 * @param obj - object to test
 * @public
 */
exports.isUserAccessGrantee = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "user";
};
/**
 * Tests whether the provided object is an instance of {@link IUserGroupAccessGrantee}.
 *
 * @param obj - object to test
 * @public
 */
exports.isUserGroupAccessGrantee = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "group";
};
//# sourceMappingURL=index.js.map